'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportErrorAction = undefined;

var _errorActionGetters = require('../error-actions/operators/errorActionGetters');

var _actionToSentryFingerprint = require('../error-actions/operators/actionToSentryFingerprint');

var _reportError = require('./reportError');

/**
 * @description Fingerprint and report an error contained withing an action
 * @param {Object} action Action containing an error to report
 */
var reportErrorAction = exports.reportErrorAction = function reportErrorAction(action) {
  var error = (0, _errorActionGetters.getError)(action) || new Error(action.type + ' is being dispatched without an error');

  // eslint-disable-next-line no-console
  console.error('Error report triggered by \'' + action.type + ' (Silent: ' + !!(0, _errorActionGetters.isSilent)(action) + ')');

  return (0, _reportError.reportError)({
    error: error,
    fingerprint: (0, _actionToSentryFingerprint.actionToSentryFingerprint)(action),
    tags: {
      isGenericErrorMessage: (0, _errorActionGetters.getErrorTitle)(action) === undefined && (0, _errorActionGetters.isSilent)(action) === false
    }
  });
};